import { render, staticRenderFns } from "./SaveOrDiscardStep.vue?vue&type=template&id=0d59d9dc"
import script from "./SaveOrDiscardStep.vue?vue&type=script&lang=ts"
export * from "./SaveOrDiscardStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports